






























	import { Component, } from "../../../Infrastructure/CorBase/CoreBase";
	import SettingListBase from "./SettingListBase";

	@Component
	export default class SettingGlobalList extends SettingListBase {     

		queryBase2: any;
		private goBackPage(): void {
			this.goBackPageBase();
		}

		descriptionName() {
	
            return this.$t('setting.descriptionGlobal');
		}

        private showDetail():boolean {
            return this.allowEditBase();
        }

		created() {
			this.isGlobalSetting = true;
		//	this.setIsGlobalSetting();
			this.initializeRightsLocal();
            this.createdBase();
			super.setAlertModalId('alertModalSettingList');
			super.created();
			super.setDetailName('SettingDetail');
			this.idSettingGroup = String(this.$route.query['idSettingGroup']);
            this.loadDefault(this.idSettingGroup);
		}


		loadFilters(value: any) { super.loadFilters(value); };
		detailClick(elementId: any) { super.detailClick(elementId); };


	};
